import React, {useEffect, useState} from 'react';
import {connect} from 'react-redux';
import * as actions from '../../store/actions/index';
import {Link as RouterLink, useHistory} from "react-router-dom";
import Link from '@material-ui/core/Link';
import Grid from '@material-ui/core/Grid';
import LockIcon from '@material-ui/icons/Lock';
import InputAdornment from '@material-ui/core/InputAdornment';
import EmailIcon from '@material-ui/icons/Email';
import {getFormData, inputChangedHandler, prepareFormData, updateObject, validateForm} from "../../shared/utility";
import CircularProgress from "@material-ui/core/CircularProgress/CircularProgress";
import Alert from "@material-ui/lab/Alert";
import {makeStyles} from "@material-ui/core/styles";
import {green} from "@material-ui/core/colors";
import TextField from "@material-ui/core/TextField";
import {Box, IconButton, Button} from "@material-ui/core";
import {Visibility, VisibilityOff} from "@material-ui/icons";
import {LoginFormStorage} from '../../shared/authUtility';


const useStyles = makeStyles((theme) => ({
    form: {
        width: '100%', // Fix IE 11 issue.
        marginTop: theme.spacing(1),
    },

    buttonProgress: {
        color: green[500],
        position: 'absolute',
        top: '50%',
        left: '50%',
        marginTop: -12,
        marginLeft: -12,
    },
    wrapper: {
        marginTop: "10px",
        marginBottom: "10px",
        position: 'relative',
    }
}));


let formData = {
    controls: {
        email: {
            label: 'Email Address',
            value: '',
            validation: {
                presence: {allowEmpty: false}, 
                email: { message: 'is not a valid' }
            },
            valid: false,
            touched: false,
        },
        password: {
            label: 'Password',
            value: '',
            validation: {
                presence: {allowEmpty: false},
                length: {minimum: 8, allowEmpty: false}
            },
            valid: false,
            touched: false,
            showPassword: false,
        }
    },

    loading: false,
    valid: false,
    touched: false,
    generalError: null

};

// formData.controls.email.value = Auth0Config.testUser.email;
// formData.controls.password.value = Auth0Config.testUser.password;

const Login = (props) => {
    const history = useHistory();

    const classes = useStyles();
    formData = prepareFormData(formData);
    //formData.controls.email.value = props.loginFormEmail ? props.loginFormEmail : '';
    const [formState, setFormState] = useState(formData);
    const [verificationState, setVerificationState] = useState({
        show: false,
        loading: false,
        message: ''
    });

    useEffect(() => {
        if (props.isAuthenticated) {
            props.hasTemporaryPassword ? history.push('/set-password') : history.push('/dashboard')
        }
    });

    const emailField = formState.controls.email;
    const passwordField = formState.controls.password;

    useEffect(() => {
        const loginData = LoginFormStorage.get();
        if (props.userMustVerifyEmail) {
            loginData && (emailField.value = loginData.email);
            setVerificationState({
                ...verificationState,
                show: true
            });
        }
    }, [props.userMustVerifyEmail, emailField.value])

    useEffect(() => {
        if (props.loginFormEmail) {
            formState.controls.email.value = props.loginFormEmail;
            setFormState({ ...formState });
        }
    }, [props.loginFormEmail]);


    const submitHandler = async (event) => {
        event.preventDefault();
        props.onAuthErrorReset();
        if (validateForm(formState, setFormState)) {
            if (verificationState.show) {
                setVerificationState({
                    ...verificationState,
                    show: false
                });
            }
            const data = getFormData(formState)
            LoginFormStorage.save({ email: formState.controls.email.value });
            props.onAuth(data, (redirect) => {
                if (redirect)
                    history.push(redirect)
            });
        }

    }
    const passShowedHandler = () => {
        const updatedState = updateObject(formState.controls);
        updatedState.password.showPassword = !updatedState.password.showPassword
        setFormState(updateObject(formState, {controls: updatedState}));
    }
    const onForgotPassword = () => {
        props.onAuthErrorReset();
    }

    const onResendVerificationEmail = async (event) => {
        props.onAuthErrorReset();
        if (!validateForm(formState, setFormState, ['email'])) {
            return ;
        }
        const email = formState.controls.email.value;
        setVerificationState({
            ...verificationState,
            loading: true
        });
        props.sendEmailConfirmation(email, (err, data) => {
            setVerificationState({
                ...verificationState,
                loading: false,
                show: false
            });
            props.authSetUserVerification(false);

            if (err) {
                console.error(err);    
                return ;
            }
        })
    }

    const resendVerificationCode = verificationState.show ? (<div className={classes.wrapper}>
        <Button type={"button"} fullWidth  color={"primary"} size={"large"} className="LoginButton"
                disabled={props.loading} onClick={onResendVerificationEmail}>Resend verification email</Button>
        {props.loading && <CircularProgress size={24} className={classes.buttonProgress}/>}
    </div>) : '';

    return (
        <React.Fragment>
            <Box align={'center'} style={{marginBottom: '25px', fontWeight: "bold"}}>
                Proceed with your log in below
            </Box>
            <form className={classes.form} noValidate onSubmit={submitHandler}>
                <div>
                    <TextField
                        name={emailField.key}
                        value={emailField.value}
                        type={'input'}
                        placeholder={emailField.label}
                        fullWidth
                        margin="normal"
                        variant="outlined"
                        onChange={event => inputChangedHandler(formState, setFormState, event.target.value, emailField.key)}
                        helperText={emailField.helperText}
                        error={!emailField.valid && emailField.touched}
                        InputProps={{
                            startAdornment: (
                                <InputAdornment position="start">
                                    <EmailIcon/>
                                </InputAdornment>
                            ),
                        }}
                        InputLabelProps={{shrink: true}}
                    />
                </div>
                <div>
                    <TextField
                        name={passwordField.key}
                        value={passwordField.value}
                        type={passwordField.showPassword ? 'input' : 'password'}
                        placeholder={passwordField.label}
                        variant="outlined"
                        fullWidth
                        margin="normal"
                        onChange={event => inputChangedHandler(formState, setFormState, event.target.value, passwordField.key)}
                        helperText={passwordField.helperText}
                        error={!passwordField.valid && passwordField.touched}
                        InputProps={{
                            startAdornment: (
                                <InputAdornment position="start">
                                    <LockIcon/>
                                </InputAdornment>
                            ),
                            endAdornment: (<InputAdornment position="end">
                                <IconButton
                                    className="AdornmentIconButton"
                                    onClick={passShowedHandler}
                                    edge="end"
                                >
                                    {passwordField.showPassword ? <Visibility/> : <VisibilityOff/>}
                                </IconButton>
                            </InputAdornment>)
                        }}
                    />

                </div>

                {props.error &&
                <div>
                    <Alert severity="error">{props.error.message ?? ''}</Alert>
                </div>
                }

                {resendVerificationCode}

                <div className={classes.wrapper}>
                    <Button type={"submit"} fullWidth variant={"contained"} color={"primary"} size={"large"}
                            disabled={props.loading} className="LoginButton"> Log In</Button>
                    {props.loading && !verificationState.loading && <CircularProgress size={24} className={classes.buttonProgress}/>}
                </div>
            </form>

            <Grid container alignContent={"center"}>
                <Grid item align="center" style={{width: '100%'}}>
                    <span className="input-group-btn">
                        <Link component={RouterLink} to="/forgot-password" variant="body2" style={{fontSize: "12px"}} onClick={onForgotPassword}>
                            Forgot my password
                        </Link>
                    </span>
                </Grid>
            </Grid>
        </React.Fragment>
    );
}

const mapStateToProps = state => {
    return {
        loading: state.auth.loading,
        error: state.auth.error,
        isAuthenticated: state.auth.isAuthenticated,
        hasTemporaryPassword: state.auth.hasTemporaryPassword,
        userMustVerifyEmail: state.auth.userMustVerifyEmail,
        loginFormEmail: state.auth.loginFormEmail
    };
};

const mapDispatchToProps = dispatch => {
    return {
        onAuth: (data, onRedirect) => dispatch(actions.auth(data.email, data.password, onRedirect)),
        onCheckSession: (token, cb) => dispatch(actions.checkSession(token, cb)),
        onAuthError: (error) => dispatch(actions.authError(error)),
        onAuthErrorReset: () => dispatch(actions.authStop()),
        sendEmailConfirmation: (email, cb) => dispatch(actions.sendEmailConfirmation(email, cb)),
        authSetUserVerification: (mustVerify) => dispatch(actions.authSetUserVerification(mustVerify)) 
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(Login);